<template>
    <TabLayout
        :title="Lang.get('employeedashboard::pages/settings/preferred-language.title')"
        :subtitle="Lang.get('employeedashboard::pages/settings/preferred-language.subtitle')"
        :tabName="'preferredLanguage'"
    >
        <form @submit.prevent="submit()" class="row">
            <div class="col-12">

                <div class="form-group col-12 col-xl-6">
                    <radio-input
                        :label="Lang.get('employeedashboard::shared.preferred_language')"
                        v-model="form.locale"
                        :options="locales"
                        @input="setLanguage"
                        :error="form.errors['locale']"
                    >
                    </radio-input>
                </div>

            </div>

            <div class="col-12">
                <SubmitButton class="mt-3 mb-4">
                    {{ Lang.get('employeedashboard::shared.save.button') }}
                </SubmitButton>
            </div>

        </form>

    </TabLayout>
</template>

<script>
import TabLayout from "@/Pages/Settings/Shared/TabLayout"
import FlashMessages from "@/Shared/FlashMessages";
import Checkbox from "@/Shared/Checkbox";
import SubmitButton from "@/Shared/SubmitButton";
import RadioInput from "@/Shared/RadioInput";

export default {
    metaInfo: {title: Lang.get('employeedashboard::pages/settings/preferred-language.title')},
    components: {
        RadioInput,
        TabLayout,
        Checkbox,
        FlashMessages,
        SubmitButton,
    },
    props: {
        errors: Object,
        account_locale: {
            required: true,
            type: String,
        },
        locales: {
            type: [Array, Object],
            required: true,
        }
    },

    data() {
        return {
            form: this.$inertia.form({
                locale: this.account_locale,
            })
        }
    },

    methods: {
        submit() {
            this.form.put(
                this.route('nl.employeedashboard.settings.account.language.update'),
                {
                    // For some reason setting preserveState was not working here. We need a full reload here, so the
                    // application is displayed in the newly set preferred language.
                    onSuccess: () => {
                        window.location.reload();
                    }
                }
            );
        },
        setLanguage(languageKey) {
            this.form.locale = languageKey
        }
    },
}
</script>
